<template>
  <div>
    <div data-v-8a75a126="" class="header__top-wrapper">
      <div data-v-8a75a126="" class="van-nav-bar van-nav-bar--fixed fixed-top rounded-corners nav-header">
        <div class="van-nav-bar__content">
          <div class="van-nav-bar__left" @click="$router.back()">
            <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
          </div>
          <div class="van-nav-bar__title van-ellipsis"></div>
        </div>
      </div>
    </div>
    <div style="height: 46px"></div>
    <div style="height: calc(100vh - 46px); overflow-y: scroll; -webkit-overflow-scrolling: touch">
      <div data-v-40995d88="" class="c-main">
        <div data-v-40995d88="" class="header" style="height: 6rem"></div>
        <div data-v-40995d88="" class="wrap-content" style="z-index: 200; top: -1.5rem; padding-bottom: 20px">
          <div data-v-40995d88="" class="clearfix header-txt">
            <span data-v-40995d88="" class="fl"
              ><img
                data-v-40995d88=""
                style="width: 4.3rem; margin-top: 0.5rem"
                src="data:image/png;base64,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"
                alt=""
            /></span>
          </div>
          <div data-v-4171953d="" data-v-40995d88="" class="download-list">
            <div data-v-4171953d="" class="hot-cont">
              <div data-v-4171953d="" class="hot-item" style="width: 90%; height: 3rem">
                <span data-v-4171953d="" class="lf-txt">推荐</span>
                <div data-v-4171953d="" class="cont">
                  <img data-v-4171953d="" style="width: 3rem; height: 3rem" src="/static/image/icon-new-wb.png" alt="" class="img" />
                  <div data-v-4171953d="">
                    <span data-v-4171953d="" class="name" style="font-size: 0.4rem; padding-top: 0.5rem"> {{ $store.state.appInfo.title }}APP </span><span style="font-size: 0.3rem" data-v-4171953d="" class="desc"> 专业体育比分客户端 </span
                    ><span data-v-4171953d="" style="width: 2rem; display: flex; align-items: center; justify-content: center; margin-top: 0.2rem; padding: 0; height: 0.7rem; border-radius: 0.4rem" @click="$parent.downloadUrl($store.state.appInfo.ios_download_url)" class="bt-txt">点击下载</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {
      url: null,
      activeNames: [],
    };
  },
  created() {
    let that = this;
  },
  methods: {},
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/app.f27f4646.css';
.wrap-content {
  width: 90% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/app.vue